import {Button, Col, Spinner} from "react-bootstrap";
import Table from "../Table/Table";
import React, {useRef} from "react";
import {TbCopy} from "react-icons/tb";

export default function SshCommandsTable(props) {
    const wideHeaderStyle = {minWidth: 150, fontSize: 14};
    const colStyle = {maxWidth: 100, fontSize: 14, whiteSpace: 'nowrap'};
    const filtersRefs = useRef([]);
    const commandNameFilterRef = useRef();
    const commandFilterRef = useRef();

    const commandFormatter = (cell) => {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className={'d-inline-block'}>
                </div>
                <div style={{overflow: 'hidden', textOverflow: 'ellipsis'}} className={'d-inline-block'}>{cell}</div>
                <div className={'d-inline-block'}>
                    <Button onClick={() => props.copyTextToClipboard(cell)} className='p-0 m-0' variant={'link'} style={{color: 'black'}}>
                        <TbCopy size={25}/>
                    </Button>
                </div>
            </div>
        );
    }

    const columns = [
        {dataField: 'command', text: 'Commands', headerStyle: wideHeaderStyle, style: colStyle, formatter: commandFormatter, editable: false},

    ];

    const resetFilters = () => {
        filtersRefs.current.forEach(currFilter => {
            if (currFilter) currFilter('');
        })
        commandNameFilterRef.current?.resetFilter();
        commandFilterRef.current?.resetFilter();
    }

    return (<>
        {(!props || props.data?.length === 0) &&
            <Col md={{offset: 5, span: 1}}><Spinner animation="border" variant="primary"/></Col>}
        {props.data?.length > 0 && <div>
            <Table
                data={props.data}
                columns={columns}
                pageSize={15}
                disablePagination
                resetFilters={resetFilters}/>
        </div>}
    </>)
}
